module.exports = __webpack_public_path__ + "4025582f890bec42b5887cbd2916ecc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/plugin-img001.png
// module id = 900
// module chunks = 3